/*
 * @Author: edvardchen
 * @Date:   2016-11-23 17:47:02
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-06-21 16:52:16
 */
import React from 'react';
import PropTypes from 'prop-types';

import './VideoDBLink.scss';

export default function VideoDBLink({ text, onClick }) {
  return (
    <h3 className="text" onClick={onClick}>
      <i className="G-ico G-ico-share G-ico-tbs shareIcon"></i>
      <span>{text}</span>
    </h3>
  );
}

VideoDBLink.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
};
